<div class="title">
  <h1>{{docTitle}}</h1>
  <button mat-icon-button class="button-close-x" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="annexe-container">
  @if(isPdf){
    <object [data]="safeDocLink" type="application/pdf"></object>
  } @else {
    <img [src]="safeDocLink" />
  }
</div>

<div class="button-close">
  <button mat-raised-button (click)="close()">Fermer</button>
</div>
